import { useClanSwitch } from '@/contexts/ClanSwitchContext';

export function ClanSwitchLoader() {
  const { isLoading, clanName } = useClanSwitch();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="text-center space-y-6">
        {/* Loading spinner */}
        <div className="relative">
          <div className="w-16 h-16 mx-auto border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-16 h-16 mx-auto border-4 border-transparent border-r-white/40 rounded-full animate-spin animation-delay-150"></div>
        </div>

        {/* Loading text */}
        <div className="space-y-2">
          <h3 className="text-lg font-semibold text-white">
            Chargement du clan {clanName}
          </h3>
          <p className="text-sm text-white/70">
            Préparation de votre espace familial...
          </p>
        </div>
      </div>
    </div>
  );
}